var components
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  if (!_vm._isMounted) {
    _vm.e0 = function(e) {
      return _vm.$emit("change", e)
    }

    _vm.e1 = function(e) {
      return _vm.$emit("input", e)
    }

    _vm.e2 = function(e) {
      return _vm.$emit("confirm", e)
    }
  }
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }